<template>
  <div class="home-container">
    <!-- 导航 -->
    <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
 
    <div class="top_bg">
      <div class="container_box">
        <div style="font-size: 50px;">供应链介绍</div>
        <div style="font-size: 20px;margin-top: 20px;font-size: 20px;">一站式供应链平台、提高效率降低成本</div>
      </div>
    </div>
    <!-- 跑马灯 -->
    <div class="title_1">供应链</div>
    <div class="text_1">合作共赢·共筑美业生态圈</div>
    <div class="carousel_container">
      <el-carousel height="400px">
        <el-carousel-item>
          <div style="display: flex;background: #fff">
            <div class="img_banner1">
              <img :src="img_banner1" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="img_box">
              <div class="img_title1">店家展示、厂商入驻</div>
              <div class="img_title2">打破时间与空间限制，精选优质货源，整合美业资源，通过找美网供应链，提高品牌知名度，增加产品曝光度，打造行业标杆形象</div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div style="display: flex;background: #fff">
            <div class="img_banner1">
              <img :src="img_banner2" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="img_box">
              <div class="img_title1">寻求报道、申请合作</div>
              <div class="img_title2">找美网专注于美业发展，拥有落地的SaaS云服务系统，专业的美业产业供应链平台；提供优质项目报道，挖掘行业创新价值</div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div style="display: flex;background: #fff">
            <div class="img_banner1">
              <img :src="img_banner3" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="img_box">
              <div class="img_title1">一站式供应链平台</div>
              <div class="img_title2">找美网供应链商场为美业供应商、店家及终端消费者，提供一站式的云采购、云拓客、云营销平台，把传统美业的线下供应互联网化</div>
            </div>
          </div>
        </el-carousel-item>
        <!-- <el-carousel-item>
          <div style="display: flex;background: #fff">
            <div class="img_banner1">
              <img :src="img_banner1" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="img_box">
              <div class="img_title1">店家展示、厂商入驻</div>
              <div class="img_title2">打破时间与空间限制，精选优质货源，整合美业资源，通过 找美网供应链，提高品牌知名度，增加产品曝光度，打造行 业标杆形象</div>
            </div>
          </div>
        </el-carousel-item> -->
      </el-carousel>
    </div>
    <!-- 美业资讯平台 -->
    <div class="beauty_box">
      <div style="padding-top: 43px" class="title_2">美业资讯平台</div>
      <div class="text_2">一号互通拥有多种端口软件服务</div>
      <div class="color_box">
        <div class="color_box1"></div>
        <div class="color_box2"></div>
        <div class="color_box3"></div>
      </div>
      <div class="text_3">全方位美业平台·专业化资讯平台，提供全面美业资讯、在线交流、轻松了解美业动态</div>
      <div class="menu_box">
        <div style="width: 511px;">
          <div>
            <div class="zm1">美业头条</div>
            <div class="zm2">提供美业全方位最新资讯、行业动态、管理技巧，尽在找美网</div>
          </div>
          <div style="margin-top: 52px;">
            <div class="zm1">美业说法</div>
            <div class="zm2">专业美业律师在线交流，为您分享美业痛点，给您解答各类疑惑</div>
          </div>
          <div style="margin-top: 52px;">
            <div class="zm1">在线选择</div>
            <div class="zm2">通过供应链平台实现品项、院装、产品、厂商、项目资源在线选择</div>
          </div>
          <div style="margin-top: 52px;">
            <div class="zm1">工厂OEM</div>
            <div class="zm2">多家知名的OEM厂商入驻，降低生产成本，提高品牌附加值</div>
          </div>
        </div>
        <div style="width: 469px;height:415px;margin-left: 209px;">
          <img :src="picture1" alt="" style="width: 100%;height: 100%;">
        </div>
      </div>
    </div>
    <!-- 美业供应平台 -->
    <div class="sup_box">
      <div style="padding-top: 43px" class="title_2">美业供应平台</div>
      <div class="text_2">一号互通拥有多种端口软件服务</div>
      <div class="color_box">
        <div class="color_box1"></div>
        <div class="color_box2"></div>
        <div class="color_box3"></div>
      </div>
      <div class="text_3">全方位美业平台·专业化资讯平台，提供全面美业资讯、在线交流、轻松了解美业动态</div>
      <div class="menu_box2">
        <div style="width: 590px;height:563px;margin-right: 105px">
          <img :src="picture2" alt="" style="width: 100%;height: 100%;">
        </div>
        <div style="width: 529px;height: 502px;">
          <div style="display: flex;align-items: center;margin:10px 14px;">
            <img :src="picture3" alt="" style="width: 40px;height: 40px;">
            <div style="font-size: 24px;margin-left: 5px;">美业供应链</div>
            <div style="width: 40px;height: 20px;background: #0091FF;color: #fff;text-align: center;margin-left: 5px">优质
            </div>
          </div>
          <div style="font-size: 17px;margin:10px 14px">优质美业商城.完善供应链,拥有特效仪器、爆品院装、优质品项,知名厂商汇集平台</div>
          <div style="display: flex;margin: 30px 14px;align-items: flex-start;">
            <div class="cloud"></div>
            <div style="margin-left: 10px;">
              <div class="list">爆品院装</div>
              <div class="list2">人气爆品、质量保障，优质厂家直供货源，告别经销商赚差价</div>
            </div>
          </div>
          <div style="display: flex;margin: 30px 14px;align-items: flex-start;">
            <div class="cloud"></div>
            <div style="margin-left: 10px;">
              <div class="list">优质品项</div>
              <div class="list2">平台严格筛选，品项齐全，在线购买，降低时间成本，增加利润空间</div>
            </div>
          </div>
          <div style="display: flex;margin: 30px 14px;align-items: flex-start;">
            <div class="cloud"></div>
            <div style="margin-left: 10px;">
              <div class="list">厂家货源</div>
              <div class="list2">各大品牌集聚平台，直接对接厂商，省去中间环节，彻底解决货源难题</div>
            </div>
          </div>
          <div style="display: flex;margin: 30px 14px;align-items: flex-start;">
            <div class="cloud"></div>
            <div style="margin-left: 10px;">
              <div class="list">特效仪器</div>
              <div class="list2">科技美容、特效仪器，多款高端美容仪器任您选购，省心更省钱</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 更多功能  -->
    <div class="more">
      <div style="padding-top:65px;" class="title_2">更多功能</div>
      <div style="font-size: 20px;color: #585858;text-align: center;margin-top:10px">低成本、高收益</div>
      <div class="more_box">
        <div>
          <div class="imgs">
            <img :src="shop" alt="" style="width: 100%;height: 100%;">
          </div>
          <div class="imgs_text">人气店铺</div>
        </div>
        <div>
          <div class="imgs">
            <img :src="hot" alt="" style="width: 100%;height: 100%;">
          </div>
          <div class="imgs_text">热销产品</div>
        </div>
        <div>
          <div class="imgs">
            <img :src="party" alt="" style="width: 100%;height: 100%;">
          </div>
          <div class="imgs_text">活动专区</div>
        </div>
        <div>
          <div class="imgs">
            <img :src="kill" alt="" style="width: 100%;height: 100%;">
          </div>
          <div class="imgs_text">限时秒杀</div>
        </div>
        <div>
          <div class="imgs">
            <img :src="double" alt="" style="width: 100%;height: 100%;">
          </div>
          <div class="imgs_text">二手专区</div>
        </div>
        <div>
          <div class="imgs">
            <img :src="study" alt="" style="width: 100%;height: 100%;">
          </div>
          <div class="imgs_text">技能培训</div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <RMBottomDiv></RMBottomDiv>
  </div>
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue'
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import * as types from "../store/mutation-types";
  export default {
    components: {RMTopDiv,RMBottomDiv},
    data() {
      return {
        img_banner1: require('../../static/img/supply/1.png'),
        img_banner2: require('../../static/img/supply/2.png'),
        img_banner3: require('../../static/img/supply/3.png'),
        picture1: require('../../static/img/ic_two.png'),
        picture2: require('../../static/img/04.png'),
        picture3: require('../../static/img/one.png'),
        shop: require('../../static/img/supply/ic_store.png'),
        hot: require('../../static/img/supply/ic_product.png'),
        party: require('../../static/img/supply/ic_liwu.png'),
        kill: require('../../static/img/supply/ic_kill.png'),
        double: require('../../static/img/supply/ic_double.png'),
        study: require('../../static/img/supply/ic_learn.png'),
        scroll: '',
        scroll100: true,
        scroll700: false
      };
    },
    watch: {
      scroll: function () {      
        this.loadSroll();
      }
    },
    methods: {
      //首页
      goToHome() {
        this.$router.push('/')
      },
      //产品中心-店务系统介绍
      goToDw() {
        this.$router.push('./home')
      },
      //产品中心-供应链
      goToSupply() {
        this.$router.push('./supplyChain')
      },
      //产品中心-营销工具
      goToMark() {
        this.$router.push('./marketingTools')
      },
      //关于我们-公司简介
      goToUS() {
        this.$router.push('./company')
      },
      //关于我们-合作渠道
      goToChannel() {
        this.$router.push('./channels')
      },
      //关于我们-招聘
      goToContact() {
        this.$router.push('./contact')
      },
      //关于我们-企业文化
      goToCulture() {
        this.$router.push('./culture')
      },
     //找美商学院-商学院文化
     goToCollege(){
        this.$router.push("./school");
      },
      //找美商学院-走进阿里
      goToAli(){
        this.$router.push("./Ali");
      },
       //找美商学院-行程安排
      gotoTravell(){
        this.$router.push('./Travell')
      },
       //找美商学院-讲师简介
      goToTeach(){},
       //找美商学院-相关案例
      goToCase(){},
      dataScroll(event) {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
      },
      loadSroll: function () {
        if (this.scroll <= 100) {
          this.scroll100 = true
        } else {
          this.scroll100 = false
        }
        if (this.scroll > 100) {
          this.scroll700 = true
        } else {
          this.scroll700 = false
        }
      },
    },
    created() {

    },

    computed: {
      ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])

    },
    mounted() {
      //获取高度
      window.addEventListener("scroll", this.dataScroll, true);
    }
  };
</script>

<style scoped lang="scss">
  @import "../assets/css/them.scss";

  .home-container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: fixed;
    overflow-y: scroll;
  }

  .top_bg {
    background-image: url('../../static/img/supply/ic_supply.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 824px;
    position: relative;
    top: 0;
    left: 0;
  }

  .container_box {
    z-index: 1000;
    position: absolute;
    top: 38%;
    left: 0;
    color: #fff;
    text-align: center;
    width: 100%;
    min-width: 769px;
  }

  .title_1 {
    font-size: 40px;
    color: #252525;
    font-weight: 500;
    margin-top: 40px;
    text-align: center;
    font-family:PingFangSC-Regular,PingFang SC;
  }

  .text_1 {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(37, 37, 37, 1);
    line-height: 25px;
    letter-spacing: 1px;
    /* width: 589px; */
    text-align: center;
    /* margin-left: 34.79%; */
    margin-top: 24px;
  }

  .carousel_container {
    width: 1200px;
    height: 400px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 66px;
  }

  .img_banner1 {
    width: 592px;
    height: 400px;
  }

  .img_box {
    width: 608px;
    height: 400px;
    background: rgba(247, 249, 250, 1);
  }

  .img_title1 {
    font-size: 30px;
    font-weight: 600;
    color: rgba(37, 37, 37, 1);
    line-height: 42px;
    margin-top: 107px;
    margin-left: 57px;
  }

  .img_title2 {
    font-size: 18px;
    font-weight: 400;
    color: rgba(37, 37, 37, 1);
    line-height: 34px;
    letter-spacing: 1px;
    margin: 24px 57px;
  }

  .beauty_box {
    width: 100%;
    height: 717px;
    background: rgba(248, 249, 253, 1);
    /* opacity: 0.5343; */
  }

  .title_2 {
    font-size: 30px;
    color: #000;
    text-align: center;
    font-weight: 600;
    font-family:PingFangSC-Semibold,PingFang SC;
  }

  .text_2 {
    text-align: center;
    font-size: 18px;
    color: #4B4B4B;
    margin-top: 7px;
    font-weight: 500
  }

  .text_3 {
    margin-top: 18px;
    font-size: 18px;
    color: #838383;
    text-align: center
  }

  .menu_box {
    margin: 0 auto;
    width: 1200px;
    margin-top: 48px;
    display: flex;
  }

  .zm1 {
    font-size: 24px;
    color: #2F2F2F;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .zm2 {
    font-size: 17px;
    color: #626262;
    line-height: 18px;
    margin-top: 5px;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .sup_box {
    background: #fff;
    width: 100%;
  }

  .menu_box2 {
    margin: 0 auto;
    width: 1200px;
    margin-top: 49px;
    display: flex;
    /* align-items: center; */
    margin-bottom: 30px;
  }

  .cloud {
    width: 10px;
    height: 10px;
    background: #0091FF;
    transform: rotate(45deg);
    margin-top: 10px;
  }

  .list {
    font-size: 22px;
    color: #2F2F2F;
  }

  .list2 {
    font-size: 17px;
    color: #626262;
    margin-top: 10px;
  }

  .more {
    width: 100%;
    height: 400px;
    background: rgba(248, 249, 253, 1);
    margin-top: 100px;
  }

  .more_box {
    width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
   
  }

  .imgs {
    width: 50px;
    height: 50px;
    margin-left: 8px;
  }

  .imgs_text {
    margin-top: 15px;
    font-size: 17px;
    color: #3C3C3C;
  }
</style>


// WEBPACK FOOTER //
// src/page/supplyChain.vue